export const trangThaiGoiDv = {
    chua_hoat_dong: "CHUA_HOAT_DONG",
    hoat_dong: 'HOAT_DONG',
    tam_ngung: 'TAM_NGUNG',
    sap_het_han: "SAP_HET_HAN",
    het_han: 'HET_HAN',
    hoan_thanh: 'HOAN_THANH',
}